import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Dashboard from './screens/Dashboard/Dashboard';
import DevDetails from './screens/Details/DevDetails';

import './App.scss';
import NavBar from './components/NavBar/NavBar';
import About from './screens/About/About';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Switch>
        <Route exact path="/" component={Dashboard} />
        <Route exact path="/about" component={About} />
        <Route exact path="/dev/:id" component={DevDetails} />
      </Switch>
    </div>
  );
}

export default App;
